(function () {
    var MAX_TRIES = 120;   // ~6s
    var TRY_EVERY = 50;    // ms
    var resizeTimer;

    function ready() {
        return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.owlCarousel);
    }

    function equalize() {
        var $ = window.jQuery;
        var $cards = $('#reviews .owl-item > .card-large.mh-review');
        if (!$cards.length) return;

        // reset, measure, set tallest
        $cards.css('height', 'auto');
        var max = 0;
        $cards.each(function(){ max = Math.max(max, this.offsetHeight); });
        if (max > 0) $cards.css('height', max + 'px');
    }

    function init() {
        if (!ready()) return false;
        var $ = window.jQuery;
        var $el = $('#reviews');
        if (!$el.length) return true;

        if ($el.hasClass('owl-loaded')) {
            try { $el.trigger('refresh.owl.carousel'); } catch(e){}
            equalize();
            return true;
        }

        $el.owlCarousel({
            loop: false,
            margin: 16,
            nav: false,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplaySpeed: 400,
            autoHeight: false,  // let CSS + equalizer control height
            responsive: {
                0:    { items: 1 },
                600:  { items: 3 },
                1000: { items: 3 }
            }
        });

        // Equalize after init and on Owl events
        $el.on('initialized.owl.carousel refreshed.owl.carousel resized.owl.carousel changed.owl.carousel', function(){
            // small delay to let widths settle
            setTimeout(equalize, 0);
        });

        // Also debounce window resize
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(equalize, 120);
        });

        // First run
        setTimeout(equalize, 0);
        return true;
    }

    if (init()) return;

    window.addEventListener('load', function once() {
        init(); window.removeEventListener('load', once);
    });

    var tries = 0;
    var t = setInterval(function(){
        if (init() || (++tries >= MAX_TRIES)) clearInterval(t);
    }, TRY_EVERY);
})();